import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BookingNavigationService, BookingStep } from 'src/app/services/booking-navigation/booking-navigation.service';
import { PhoneService } from 'src/app/services/phone/phone.service';

import { L10nPipe } from 'src/app/helpers/pipes/L10n.pipe';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [NgIf, L10nPipe]
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentStep: BookingStep | null = null;
  isBookingRoute = true;
  phoneNumber: string;
  showBackBtn: boolean;

  readonly totalSteps = this.bookingNavigationService.getSteps().length;

  private referrer = '';
  private hasExternalReferrer = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly phoneService: PhoneService,
    protected readonly bookingNavigationService: BookingNavigationService
  ) {}

  ngOnInit(): void {
    this.referrer = document.referrer?.trim() || '';
    this.hasExternalReferrer = !!this.referrer;
    this.bookingNavigationService.currentStep$.pipe(takeUntil(this.destroy$)).subscribe((step) => {
      this.currentStep = step;
      this.isBookingRoute = this.bookingNavigationService.isBookingRoute();
      this.showBackBtn = this.hasExternalReferrer || (this.isBookingRoute && this.currentStep.index > 0);
    });
    this.phoneNumber = this.phoneService.phoneHref;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack(): void {
    if (this.bookingNavigationService.canGoBack()) {
      this.bookingNavigationService.goBack();
    } else {
      if (this.hasExternalReferrer) {
        sessionStorage.clear();
        window.location.href = this.referrer;
        return;
      }
    }
  }
}
